var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.mobileMenuOnly ? "ul" : "div",
    {
      tag: "component",
      class: _vm.mobileMenuOnly ? "my-account-wrapper navbar-nav m-0" : null
    },
    [
      _vm.mobileMenuOnly
        ? [
            _vm.user && _vm.menu
              ? [
                  _vm._l(_vm.menuItems, function(menuItem) {
                    return [
                      menuItem.displayed !== false
                        ? _c(
                            "li",
                            {
                              key: menuItem.id,
                              staticClass: "navbar-nav-item d-lg-none pt-0 pb-2"
                            },
                            [
                              menuItem.uri
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-primary btn-pill font-weight-bold",
                                      attrs: { href: menuItem.uri }
                                    },
                                    [
                                      menuItem.icon
                                        ? _c("i", {
                                            staticClass: "mr-2",
                                            class: menuItem.icon
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(menuItem.label))
                                      ]),
                                      _vm._v(" "),
                                      menuItem.badge
                                        ? _c(
                                            "span",
                                            {
                                              class: [
                                                "badge",
                                                menuItem.badge,
                                                "ml-2"
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(menuItem.badgeCount || 1)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-primary btn-pill font-weight-bold disabled"
                                    },
                                    [
                                      menuItem.icon
                                        ? _c("i", {
                                            staticClass: "mr-2",
                                            class: menuItem.icon
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(menuItem.label))
                                      ]),
                                      _vm._v(" "),
                                      menuItem.badge
                                        ? _c(
                                            "span",
                                            {
                                              class: [
                                                "badge",
                                                menuItem.badge,
                                                "ml-2"
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(menuItem.badgeCount || 1)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.visibleChildren(menuItem), function(child) {
                        return _c(
                          "li",
                          {
                            key: child.id,
                            staticClass:
                              "navbar-nav-item d-lg-none pt-0 pb-2 pl-4"
                          },
                          [
                            child.uri
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-primary btn-pill font-weight-bold",
                                    attrs: { href: child.uri }
                                  },
                                  [
                                    child.icon
                                      ? _c("i", {
                                          staticClass: "mr-2",
                                          class: child.icon
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(child.label))]),
                                    _vm._v(" "),
                                    child.badge
                                      ? _c(
                                          "span",
                                          {
                                            class: [
                                              "badge",
                                              child.badge,
                                              "ml-2"
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(child.badgeCount || 1)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-primary btn-pill font-weight-bold disabled"
                                  },
                                  [
                                    child.icon
                                      ? _c("i", {
                                          staticClass: "mr-2",
                                          class: child.icon
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(child.label))]),
                                    _vm._v(" "),
                                    child.badge
                                      ? _c(
                                          "span",
                                          {
                                            class: [
                                              "badge",
                                              child.badge,
                                              "ml-2"
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(child.badgeCount || 1)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                          ]
                        )
                      })
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "navbar-nav-item d-lg-none pt-0 pb-4" },
                    [
                      !_vm.user.impersonated
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-sm btn-primary btn-pill font-weight-bold",
                              attrs: {
                                href: _vm.path("fos_user_security_logout")
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm._f("trans")("dict.logout")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-sm btn-danger btn-pill font-weight-bold",
                              attrs: { href: _vm.impersonationExitUrl() }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("trans")("layout.exit-impersonating")
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                    ]
                  )
                ]
              : _vm.isAnonymousVisit
              ? _c("li", { staticClass: "navbar-nav-item d-lg-none py-4" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-sm btn-primary btn-pill font-weight-bold",
                      attrs: { href: _vm.path("fos_user_security_login") }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "align-middle mb-1 mr-3",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "10.882",
                            height: "13.852",
                            viewBox: "0 0 10.882 13.852"
                          }
                        },
                        [
                          _c(
                            "g",
                            { attrs: { transform: "translate(-80.04 -32)" } },
                            [
                              _c("path", {
                                attrs: {
                                  "data-name": "Path 12",
                                  d:
                                    "M90.922,230.535a7.427,7.427,0,0,0-1.607-4.684,4.9,4.9,0,0,0-7.667,0,7.425,7.425,0,0,0-1.607,4.678,13.256,13.256,0,0,0,5.441,1.387A12.107,12.107,0,0,0,90.922,230.535Z",
                                  transform: "translate(0 -186.063)",
                                  fill: "#fafafa"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  "data-name": "Ellipse 1",
                                  cx: "2.721",
                                  cy: "2.721",
                                  r: "2.721",
                                  transform: "translate(82.76 32)",
                                  fill: "#fafafa"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("trans")(
                              "layout.link.my_account",
                              {},
                              "FOSUserBundle"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]
        : _vm.user
        ? _c(
            "div",
            {
              staticClass: "metronic-scope d-none d-lg-flex justify-content-end"
            },
            [
              _c(
                "div",
                {
                  staticClass: "topbar-item",
                  class: {
                    "user-border-right":
                      _vm.notificationsActive || _vm.messagingActive
                  },
                  attrs: { "data-offset": "10px,0px", role: "button" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-icon btn-clean btn-lg px-2",
                      class: {
                        "text-success": !_vm.user.impersonated,
                        "text-danger": _vm.user.impersonated
                      },
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.gotoUserDashboard()
                        }
                      }
                    },
                    [
                      _vm.useAvatars && _vm.avatar
                        ? _c("div", [
                            _vm.avatar
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.avatar,
                                    id: "img-avatar-top"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.avatar && _vm.user.salutation === "mr"
                              ? _c("img", {
                                  attrs: {
                                    src: "/assets/global/img/heads-male.png",
                                    id: "img-avatar-top",
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.avatar && _vm.user.salutation !== "mr"
                              ? _c("img", {
                                  attrs: {
                                    src: "/assets/global/img/heads-female.png",
                                    id: "img-avatar-top",
                                    alt: ""
                                  }
                                })
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "svg-icon svg-icon-xs mr-2",
                          class: {
                            "svg-icon-success": !_vm.user.impersonated,
                            "svg-icon-danger": _vm.user.impersonated
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "6.449",
                                height: "8.21",
                                viewBox: "0 0 6.449 8.21"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "user",
                                    transform: "translate(-80.04 -32)"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      id: "Path_12",
                                      "data-name": "Path 12",
                                      d:
                                        "M86.489,227.873a4.4,4.4,0,0,0-.952-2.776,2.9,2.9,0,0,0-4.544,0,4.4,4.4,0,0,0-.952,2.772,7.857,7.857,0,0,0,3.225.822A7.175,7.175,0,0,0,86.489,227.873Z",
                                      transform: "translate(0 -188.482)",
                                      fill: "#ffc700"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("circle", {
                                    attrs: {
                                      id: "Ellipse_1",
                                      "data-name": "Ellipse 1",
                                      cx: "1.613",
                                      cy: "1.613",
                                      r: "1.613",
                                      transform: "translate(81.652 32)",
                                      fill: "#ffc700"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.user.impersonated
                        ? _c("span", { staticClass: "topbar-item--username" }, [
                            _vm._v(
                              "Witaj " +
                                _vm._s(
                                  _vm.user.firstName
                                    ? " " + _vm.user.firstName
                                    : ""
                                )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.impersonated
                        ? _c("span", { staticClass: "topbar-item--username" }, [
                            _vm._v(
                              "Witaj " +
                                _vm._s(
                                  _vm.user.firstName
                                    ? " [" + _vm.user.firstName + "]"
                                    : ""
                                )
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.notificationsActive
                ? _c("topbar-user-notifications")
                : _vm._e(),
              _vm._v(" "),
              _vm.messagingActive ? _c("topbar-unread-messages") : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "div",
                  {
                    staticClass: "topbar-item",
                    attrs: {
                      "data-toggle": "dropdown",
                      "data-offset": "10px,0px",
                      role: "button"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "btn btn-icon btn-clean btn-dropdown btn-lg"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "svg-icon svg-icon-success svg-icon-xs"
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticStyle: { transform: "rotate(180deg)" },
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M3.95428417,19 L20.0457158,19 C20.3218582,19 20.5457158,18.7761424 20.5457158,18.5 C20.5457158,18.3982978 20.5147019,18.2990138 20.4568119,18.215395 L12.4110961,6.59380547 C12.2539131,6.36676337 11.9424371,6.31013137 11.715395,6.46731437 C11.6659703,6.50153145 11.623121,6.54438079 11.5889039,6.59380547 L3.54318807,18.215395 C3.38600507,18.4424371 3.44263707,18.7539131 3.66967918,18.9110961 C3.75329796,18.968986 3.85258194,19 3.95428417,19 Z",
                                        fill: "#000000"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-menu dropdown-menu-left dropdown-menu-md p-0"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "navi-header font-weight-bold py-5" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn btn-label-primary btn-sm btn-bold btn-font-md"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("profile.show.currentPlan")
                              ) + ": "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "text-uppercase font-weight-bold",
                                class: _vm.subscriptionColorClass
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "accounting.plan." +
                                        _vm.currentSubscription.type +
                                        ".label",
                                      [],
                                      "AppAccounting"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentSubscription.type === "free"
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-clean btn-xs btn-bold ml-2",
                                attrs: {
                                  href: _vm.path(
                                    "app_account.accounting.subscription"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("profile.show.upgradePlan")
                                  ) + "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "separator separator-solid mb-4"
                    }),
                    _vm._v(" "),
                    _vm.menuLoginItem
                      ? _c(
                          "a",
                          {
                            staticClass: "kt-notification__item",
                            attrs: { href: _vm.menuLoginItem.uri }
                          },
                          [
                            _vm.menuLoginItem.icon
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "kt-notification__item-icon mr-2"
                                  },
                                  [_c("i", { class: _vm.menuLoginItem.icon })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "kt-notification__item-details" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "kt-notification__item-title kt-font-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.menuLoginItem.label) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "navi" },
                      [
                        _vm._l(_vm.menuItems, function(menuItem) {
                          return [
                            menuItem.displayed !== false
                              ? _c(
                                  "li",
                                  {
                                    key: menuItem.id,
                                    class: _vm.menuItemClass(menuItem)
                                  },
                                  [
                                    menuItem.uri
                                      ? _c(
                                          "a",
                                          {
                                            class: _vm.menuItemLinkClass(
                                              menuItem
                                            ),
                                            attrs: { href: menuItem.uri }
                                          },
                                          [
                                            menuItem.icon
                                              ? _c("i", {
                                                  staticClass: "mr-2",
                                                  class: menuItem.icon
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(menuItem.label))
                                            ]),
                                            _vm._v(" "),
                                            menuItem.badge
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      "badge",
                                                      menuItem.badge
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        menuItem.badgeCount || 1
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            class: _vm.menuItemLabelClass(
                                              menuItem
                                            )
                                          },
                                          [
                                            menuItem.icon
                                              ? _c("i", {
                                                  class: menuItem.icon
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(menuItem.label))
                                            ]),
                                            _vm._v(" "),
                                            menuItem.badge
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      "badge",
                                                      menuItem.badge
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        menuItem.badgeCount || 1
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _vm.hasChildren(menuItem)
                                      ? _c(
                                          "ul",
                                          { staticClass: "navi" },
                                          _vm._l(menuItem.children, function(
                                            child
                                          ) {
                                            return child.displayed !== false
                                              ? _c(
                                                  "li",
                                                  {
                                                    key: child.id,
                                                    class: _vm.menuItemClass(
                                                      child
                                                    )
                                                  },
                                                  [
                                                    child.uri
                                                      ? _c(
                                                          "a",
                                                          {
                                                            class: _vm.menuItemLinkClass(
                                                              child
                                                            ),
                                                            attrs: {
                                                              href: child.uri
                                                            }
                                                          },
                                                          [
                                                            child.icon
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  class:
                                                                    child.icon
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  child.label
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            child.badge
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    class: [
                                                                      "badge",
                                                                      child.badge
                                                                    ]
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        child.badgeCount ||
                                                                          1
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            class: _vm.menuItemLabelClass(
                                                              child
                                                            )
                                                          },
                                                          [
                                                            child.icon
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  class:
                                                                    child.icon
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  child.label
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            child.badge
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    class: [
                                                                      "badge",
                                                                      child.badge
                                                                    ]
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        child.badgeCount ||
                                                                          1
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                  ]
                                                )
                                              : _vm._e()
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "separator separator-solid mt-4"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "navi-footer py-5 d-flex justify-content-center"
                      },
                      [
                        !_vm.user.impersonated
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-outline-primary btn-pill",
                                attrs: {
                                  href: _vm.path("fos_user_security_logout")
                                }
                              },
                              [_vm._v(_vm._s(_vm._f("trans")("dict.logout")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.impersonated
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-danger btn-pill",
                                  attrs: { href: _vm.impersonationExitUrl() }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("trans")(
                                        "layout.exit-impersonating"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        : !_vm.mobileMenuOnly && !_vm.user
        ? _c("div", { staticClass: "d-none d-lg-block" }, [
            _c(
              "a",
              {
                staticClass: "header-login font-weight-medium",
                attrs: { href: _vm.path("fos_user_security_login") }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("trans")(
                        "layout.link.my_account",
                        {},
                        "FOSUserBundle"
                      )
                    ) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }